import React from 'react';
import { themes, pageTypeMeta } from './themes';
import JournalPage from './JournalPage';
import RecipePage from './RecipePage';
import MemoryPage from './MemoryPage';
import TravelPage from './TravelPage';
import FitnessPage from './FitnessPage';
import ActivityPage from './ActivityPage';
import ReadingPage from './ReadingPage';
import PetPage from './PetPage';
import PregnancyPage from './PregnancyPage';

const GenericDocumentPage = ({ page, pageIndex, totalPages, theme }) => {
  const t = themes[theme] || themes['modern-minimal'];
  const meta = pageTypeMeta[page.pageType] || { label: 'Page', color: t.accent };
  return (
    <div data-testid={`document-page-${pageIndex}`} className="w-full aspect-[210/297] flex flex-col relative overflow-hidden" style={{ backgroundColor: t.cardBg }}>
      <div className="h-1.5 w-full" style={{ backgroundColor: t.accent }} />
      <div className="px-8 pt-6 pb-4 flex items-start justify-between">
        <div className="flex-1">
          <span className="inline-block text-[9px] font-bold tracking-[0.15em] uppercase px-2.5 py-1 rounded-full mb-3" style={{ fontFamily: t.bodyFont, backgroundColor: meta.color + '18', color: meta.color }}>{meta.label}</span>
          <h2 style={{ fontFamily: t.font, fontWeight: 700, fontSize: 'clamp(1.1rem, 3vw, 1.5rem)', color: t.text, lineHeight: 1.2 }}>{page.title}</h2>
        </div>
        <span style={{ fontFamily: t.bodyFont, fontSize: '0.7rem', color: t.subtext, opacity: 0.6 }}>{pageIndex + 1}/{totalPages}</span>
      </div>
      <div className="px-8 flex-1 overflow-hidden flex flex-col">
        {page.content && <p className="mb-3 leading-relaxed flex-shrink-0" style={{ fontFamily: t.bodyFont, fontSize: 'clamp(0.65rem, 1.3vw, 0.8rem)', color: t.subtext, lineHeight: 1.6 }}>{page.content}</p>}
        {page.fields && page.fields.length > 0 && (
          <div className={`${page.fields.length > 6 ? 'space-y-1' : 'space-y-2'} mt-1 flex-1 flex flex-col justify-evenly`}>
            {page.fields.map((field, fi) => (
              <div key={fi} className="flex items-center gap-2">
                <div className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ backgroundColor: t.accent }} />
                <span style={{ fontFamily: t.bodyFont, fontSize: page.fields.length > 6 ? '0.65rem' : '0.75rem', color: t.text, fontWeight: 500, minWidth: '90px' }}>{field}</span>
                <div className={`flex-1 ${page.fields.length > 8 ? 'h-5' : page.fields.length > 6 ? 'h-6' : 'h-8'} rounded-lg`} style={{ backgroundColor: t.fieldBg || t.bg, border: `1px solid ${t.fieldBorder || t.accent + '20'}` }} />
              </div>
            ))}
          </div>
        )}
        {(!page.fields || page.fields.length === 0) && page.pageType === 'notes' && (
          <div className="space-y-4 mt-4 flex-1">{Array.from({ length: 12 }).map((_, i) => <div key={i} className="h-px w-full" style={{ backgroundColor: t.fieldBorder || t.accent + '15' }} />)}</div>
        )}
      </div>
      <div className="px-8 py-3 flex items-center justify-between" style={{ borderTop: `1px solid ${t.accent}15` }}>
        <span style={{ fontFamily: t.bodyFont, fontSize: '0.6rem', color: t.subtext, opacity: 0.5, letterSpacing: '0.1em' }}>LUMERA STUDIO</span>
        <span style={{ fontFamily: t.bodyFont, fontSize: '0.6rem', color: t.subtext, opacity: 0.5 }}>Page {pageIndex + 1}</span>
      </div>
    </div>
  );
};

/* Router: delegates to specialized page renderers based on pageType prefix */
const DocumentPage = (props) => {
  const pt = props.page?.pageType || '';
  if (pt.startsWith('journal-')) return <JournalPage {...props} />;
  if (pt.startsWith('recipe-')) return <RecipePage {...props} />;
  if (pt.startsWith('memory-')) return <MemoryPage {...props} />;
  if (pt.startsWith('travel-')) return <TravelPage {...props} />;
  if (pt.startsWith('fitness-')) return <FitnessPage {...props} />;
  if (pt.startsWith('activity-')) return <ActivityPage {...props} />;
  if (pt.startsWith('reading-')) return <ReadingPage {...props} />;
  if (pt.startsWith('pet-')) return <PetPage {...props} />;
  if (pt.startsWith('pregnancy-')) return <PregnancyPage {...props} />;
  return <GenericDocumentPage {...props} />;
};

export default DocumentPage;
